/**
 * DDS Quiz 2.0 — Flow, Live Stock Check, Dynamic Volume Tiers & AJAX Cart Drawer
 */

document.addEventListener('DOMContentLoaded', () => {
  const modalOverlay = document.getElementById('dds-quiz-modal-overlay');
  if (!modalOverlay) return;

  const btnStart = document.getElementById('btn-start-quiz');
  const btnNext = document.getElementById('btn-next');
  const btnPrev = document.getElementById('btn-prev');
  const btnRestart = document.getElementById('btn-restart');
  const closeBtn = document.getElementById('dds-quiz-close');
  const closeBtnAlt = document.getElementById('dds-quiz-close-alt');
  const topBar = document.getElementById('dds-quiz-top-bar');
  const modalContent = document.querySelector('.dds-quiz-modal-content');

  const step0 = document.getElementById('step-0');
  const questionsContainer = document.getElementById('dds-quiz-questions-container');
  const stepLabel = document.getElementById('dds-quiz-step-label');
  const pctLabel = document.getElementById('dds-quiz-pct-label');
  const progressBar = document.getElementById('dds-quiz-progress-bar');

  let currentStep = 0;
  let autoAdvanceTimer = null;
  const answers = { q1: null, q2: null, q3: null, q4: null };

  function formatLei(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function hasUnavailableTag(prod) {
    if (!prod || !Array.isArray(prod.tags)) return false;
    return prod.tags.some(t => String(t).toLowerCase().trim() === 'indisponibil');
  }

  // Open / Close Modal
  document.querySelectorAll('a[href="#quiz"], .dds-quiz__btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      resetQuiz();
      modalOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });
  });

  const closeModal = () => {
    if (autoAdvanceTimer) clearTimeout(autoAdvanceTimer);
    modalOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  };
  closeBtn.addEventListener('click', closeModal);
  closeBtnAlt.addEventListener('click', closeModal);

  function resetQuiz() {
    if (autoAdvanceTimer) clearTimeout(autoAdvanceTimer);
    currentStep = 0;
    answers.q1 = answers.q2 = answers.q3 = answers.q4 = null;
    document.querySelectorAll('.dds-quiz-option').forEach(opt => opt.classList.remove('is-selected'));
    document.getElementById('dds-quiz-result-card').innerHTML = '';
    const whyBox = document.getElementById('dds-quiz-why-box');
    if (whyBox) whyBox.innerHTML = '';
    showStep(0);
  }
  btnRestart.addEventListener('click', resetQuiz);

  // Select Option + Auto-advance on steps 1–3
  document.querySelectorAll('.dds-quiz-option').forEach(btn => {
    btn.addEventListener('click', function () {
      const parentStep = this.closest('.dds-quiz-step');
      parentStep.querySelectorAll('.dds-quiz-option').forEach(opt => opt.classList.remove('is-selected'));
      this.classList.add('is-selected');

      answers['q' + currentStep] = this.getAttribute('data-val');
      btnNext.disabled = false;

      if (autoAdvanceTimer) clearTimeout(autoAdvanceTimer);
      if (currentStep >= 1 && currentStep <= 3) {
        autoAdvanceTimer = setTimeout(() => {
          if (currentStep >= 1 && currentStep <= 3 && answers['q' + currentStep]) {
            currentStep++;
            showStep(currentStep);
          }
        }, 260);
      }
    });
  });

  btnStart.addEventListener('click', () => { currentStep = 1; showStep(currentStep); });

  btnNext.addEventListener('click', () => {
    if (autoAdvanceTimer) clearTimeout(autoAdvanceTimer);
    if (currentStep < 4) {
      currentStep++;
      showStep(currentStep);
    } else if (currentStep === 4) {
      startAnalysisAndFetch();
    }
  });

  btnPrev.addEventListener('click', () => {
    if (autoAdvanceTimer) clearTimeout(autoAdvanceTimer);
    if (currentStep > 1) {
      currentStep--;
      showStep(currentStep);
    }
  });

  function showStep(stepIndex) {
    document.querySelectorAll('.dds-quiz-step').forEach(s => {
      s.classList.remove('is-active');
      s.style.display = 'none';
    });

    if (stepIndex === 0) {
      step0.style.display = 'block';
      step0.classList.add('is-active');
      questionsContainer.style.display = 'none';
      topBar.style.display = 'none';
      closeBtnAlt.style.display = 'flex';
      modalOverlay.style.overflow = 'hidden';
      modalContent.style.overflow = '';
      modalContent.style.height = '';
      modalContent.style.paddingTop = '';
      return;
    }

    if (stepIndex >= 1 && stepIndex <= 4) {
      step0.style.display = 'none';
      questionsContainer.style.display = 'block';
      topBar.style.display = 'flex';
      closeBtnAlt.style.display = 'none';
      modalOverlay.style.overflow = 'hidden';
      modalContent.style.overflow = 'hidden';
      modalContent.style.height = '100dvh';
      modalContent.style.paddingTop = '';

      const stepEl = document.getElementById('step-' + stepIndex);
      stepEl.style.display = 'block';
      setTimeout(() => stepEl.classList.add('is-active'), 10);

      stepLabel.innerText = `Întrebarea ${stepIndex} din 4`;
      const pct = stepIndex * 25;
      pctLabel.innerText = `${pct}% completat`;
      progressBar.style.width = pct + '%';

      btnPrev.style.visibility = stepIndex === 1 ? 'hidden' : 'visible';
      btnNext.innerText = stepIndex === 4 ? 'Vezi recomandarea mea >' : 'Continuă >';
      btnNext.disabled = !answers['q' + stepIndex];
      return;
    }

    if (stepIndex === 5 || stepIndex === 6) {
      questionsContainer.style.display = 'none';
      topBar.style.display = 'none';
      closeBtnAlt.style.display = 'flex';
      modalOverlay.style.overflow = 'auto';
      modalOverlay.style.alignItems = 'flex-start';
      modalContent.style.overflow = 'visible';
      modalContent.style.height = 'auto';
      modalContent.style.paddingTop = '65px';
      modalOverlay.scrollTop = 0;

      const stepEl = document.getElementById('step-' + stepIndex);
      stepEl.style.display = 'block';
      setTimeout(() => stepEl.classList.add('is-active'), 10);
    }
  }

  async function fetchProductJson(handle) {
    if (!handle) return null;
    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}.js`);
      if (!res.ok) return null;
      return await res.json();
    } catch (_) {
      return null;
    }
  }

  async function fetchAvailableBundle(bundleHandle) {
    if (!bundleHandle || !window.DDS_QUIZ_DATA) return null;
    const bProd = await fetchProductJson(bundleHandle);
    if (!bProd || hasUnavailableTag(bProd)) return null;
    const comps = window.DDS_QUIZ_DATA.getBundleComponents(bundleHandle);
    if (comps.length > 0) {
      const checks = await Promise.all(comps.map(c => fetchProductJson(c)));
      if (checks.some(cProd => !cProd || hasUnavailableTag(cProd))) return null;
    }
    return bProd;
  }

  async function startAnalysisAndFetch() {
    currentStep = 5;
    showStep(5);

    const an2 = document.getElementById('quiz-an-2');
    const an3 = document.getElementById('quiz-an-3');
    if (an2) { an2.classList.remove('is-done'); an2.innerText = '⏳ Selectăm extractele 100% naturale potrivite'; }
    if (an3) { an3.classList.remove('is-done'); an3.innerText = '⏳ Calculăm cura optimă pentru obiectivul tău'; }

    setTimeout(() => {
      if (an2) { an2.classList.add('is-done'); an2.innerText = '✓ Selectăm extractele 100% naturale potrivite'; }
    }, 550);
    setTimeout(() => {
      if (an3) { an3.classList.add('is-done'); an3.innerText = '✓ Calculăm cura optimă pentru obiectivul tău'; }
    }, 1100);

    const rec = window.DDS_QUIZ_DATA
      ? window.DDS_QUIZ_DATA.getRecommendation(answers)
      : { primary: 'artro-collagen', fallback: 'artro-mobil', recommendedQty: 4, whyText: '' };

    try {
      const [primaryProd, bundleProd] = await Promise.all([
        fetchProductJson(rec.primary),
        fetchAvailableBundle(rec.bundleHandle)
      ]);

      let finalProd = primaryProd;
      if (!finalProd || hasUnavailableTag(finalProd)) {
        finalProd = await fetchProductJson(rec.fallback);
      }
      if (!finalProd || hasUnavailableTag(finalProd)) {
        finalProd = await fetchProductJson('artro-collagen');
      }
      if (!finalProd) throw new Error('Product unavailable');

      renderResult(finalProd, rec, bundleProd);
      setTimeout(() => { currentStep = 6; showStep(6); }, 1550);
    } catch (err) {
      console.error('Quiz fetch error:', err);
      document.getElementById('dds-quiz-result-card').innerHTML =
        `<p style="color:#d63031; font-size:1.4rem; font-weight:600; padding:20px;">Ne pare rău, produsul recomandat nu este disponibil momentan. Vă rugăm să ne contactați telefonic la 0771 104 521.</p>`;
      setTimeout(() => { currentStep = 6; showStep(6); }, 1000);
    }
  }

  function calcTier(baseCents, qty, discPct) {
    const fullCents = baseCents * qty;
    const discCents = Math.round((fullCents * discPct) / 100);
    const finalCents = fullCents - discCents;
    const unitCents = Math.round(finalCents / qty);
    return {
      qty,
      discPct,
      fullCents,
      discCents,
      finalCents,
      unitCents,
      freeShip: finalCents >= 13900
    };
  }

  function renderResult(product, rec, bundleProd) {
    const container = document.getElementById('dds-quiz-result-card');
    const whyBox = document.getElementById('dds-quiz-why-box');
    if (whyBox && rec.whyText) whyBox.innerHTML = rec.whyText;

    let imgUrl = product.images && product.images.length > 0 ? product.images[0] : '';
    if (imgUrl) imgUrl = imgUrl.replace(/\.(jpg|png|webp)/i, '_600x600.$1');

    const baseVariant = product.variants[0];
    const baseId = baseVariant.id;
    const baseCents = baseVariant.price;
    const defaultQty = rec.recommendedQty || 4;
    const benefits = window.DDS_QUIZ_DATA ? window.DDS_QUIZ_DATA.getBenefits(product.handle) : [];

    const tiers = [
      { ...calcTier(baseCents, 1, 0), title: '1 Bucată', sub: 'Pentru testare' },
      { ...calcTier(baseCents, 4, 5), title: '4 Bucăți', sub: `${formatLei(calcTier(baseCents, 4, 5).unitCents)} / buc · Economisești ${formatLei(calcTier(baseCents, 4, 5).discCents)}` },
      { ...calcTier(baseCents, 8, 15), title: '8 Bucăți', sub: `${formatLei(calcTier(baseCents, 8, 15).unitCents)} / buc · Economisești ${formatLei(calcTier(baseCents, 8, 15).discCents)}` }
    ];

    const selectedTier = tiers.find(t => t.qty === defaultQty) || tiers[1];

    const variantsHtml = tiers.map(t => {
      const isSelected = t.qty === defaultQty;
      let topBadge = '';
      if (t.qty === 4 && defaultQty === 4) topBadge = `<span class="dds-quiz-rec-ribbon">★ CURĂ RECOMANDATĂ</span>`;
      if (t.qty === 8 && defaultQty === 8) topBadge = `<span class="dds-quiz-rec-ribbon dds-quiz-rec-ribbon--intensive">★ CURĂ INTENSIVĂ RECOMANDATĂ</span>`;
      else if (t.qty === 8 && defaultQty !== 8) topBadge = `<span class="dds-quiz-rec-ribbon dds-quiz-rec-ribbon--max">ECONOMIE MAXIMĂ -15%</span>`;

      const pills = [];
      if (t.discPct === 5) pills.push(`<span class="dds-quiz-pill dds-quiz-pill--green">-5%</span>`);
      if (t.discPct === 15) pills.push(`<span class="dds-quiz-pill dds-quiz-pill--orange">-15%</span>`);
      if (t.freeShip) pills.push(`<span class="dds-quiz-pill dds-quiz-pill--ship">Transport GRATUIT</span>`);

      return `
        <label class="dds-quiz-variant-label ${isSelected ? 'is-active' : ''} ${topBadge ? 'has-ribbon' : ''}" data-price-txt="${formatLei(t.finalCents)}">
          ${topBadge}
          <input type="radio" name="quiz_qty_selector" value="${t.qty}" ${isSelected ? 'checked' : ''} class="dds-quiz-variant-radio">
          <div class="dds-quiz-variant-left">
            <div class="dds-quiz-variant-head">
              <span class="dds-quiz-radio-dot"></span>
              <span class="dds-quiz-variant-title">${t.title}</span>
              ${pills.join('')}
            </div>
            <div class="dds-quiz-variant-sub">${t.sub}</div>
          </div>
          <div class="dds-quiz-variant-right">
            ${t.discPct > 0 ? `<span class="dds-quiz-variant-old">${formatLei(t.fullCents)}</span>` : ''}
            <span class="dds-quiz-variant-price">${formatLei(t.finalCents)}</span>
          </div>
        </label>
      `;
    }).join('');

    let bundleHtml = '';
    if (bundleProd && bundleProd.variants && bundleProd.variants[0]) {
      const bPrice30 = bundleProd.variants[0].price;
      const bDisc30 = bPrice30 - Math.round((bPrice30 * 5) / 100);
      let bImg = bundleProd.images && bundleProd.images[0] ? bundleProd.images[0].replace(/\.(jpg|png|webp)/i, '_240x240.$1') : '';
      bundleHtml = `
        <div class="dds-quiz-bundle-upsell">
          <div class="dds-quiz-bundle-upsell__tag">ALTERNATIVĂ SINERGICĂ · CURĂ 30 / 60 ZILE</div>
          <div class="dds-quiz-bundle-upsell__body">
            ${bImg ? `<img src="${bImg}" alt="${bundleProd.title}" class="dds-quiz-bundle-upsell__img">` : ''}
            <div class="dds-quiz-bundle-upsell__info">
              <div class="dds-quiz-bundle-upsell__title">${bundleProd.title}</div>
              <div class="dds-quiz-bundle-upsell__meta">Mai multe formule complementare · De la <strong>${formatLei(bDisc30)}</strong> (-5% / -15% + Transport Gratuit)</div>
            </div>
            <a href="${bundleProd.url}" class="dds-quiz-bundle-upsell__btn">Vezi Pachetul ></a>
          </div>
        </div>
      `;
    }

    container.innerHTML = `
      <div class="dds-quiz-product-card">
        <div class="dds-quiz-product-header">
          ${imgUrl ? `<img src="${imgUrl}" alt="${product.title}" class="dds-quiz-product-img">` : ''}
          <div class="dds-quiz-product-summary">
            <h4 class="dds-quiz-product-title">${product.title}</h4>
            <ul class="dds-quiz-benefits-list">
              ${benefits.map(b => `<li><span class="dds-quiz-b-check">✓</span><span>${b}</span></li>`).join('')}
            </ul>
          </div>
        </div>

        <div class="dds-quiz-variants-heading">Alege cantitatea potrivită pentru cura ta:</div>
        <div class="dds-quiz-variants">
          ${variantsHtml}
        </div>

        <button type="button" class="dds-quiz-add-btn" id="dds-quiz-atc-btn" data-vid="${baseId}" data-qty="${defaultQty}">
          <span id="dds-quiz-atc-text">Adaugă în coș — ${formatLei(selectedTier.finalCents)} ></span>
        </button>

        <div class="dds-quiz-trust-row">
          <span>🚚 Livrare rapidă DPD 1-3 zile</span>
          <span>🌿 100% Extracte Naturale</span>
          <span>🔒 Plată ramburs sau card</span>
        </div>

        <a href="${product.url}" class="dds-quiz-details-link">Vezi toate detaliile și compoziția produsului ></a>
      </div>
      ${bundleHtml}
    `;

    const atcBtn = document.getElementById('dds-quiz-atc-btn');
    const atcText = document.getElementById('dds-quiz-atc-text');
    container.querySelectorAll('.dds-quiz-variant-radio').forEach(radio => {
      radio.addEventListener('change', function () {
        container.querySelectorAll('.dds-quiz-variant-label').forEach(l => l.classList.remove('is-active'));
        const lbl = this.closest('.dds-quiz-variant-label');
        lbl.classList.add('is-active');
        if (atcBtn) atcBtn.setAttribute('data-qty', this.value);
        if (atcText && lbl) atcText.innerText = `Adaugă în coș — ${lbl.getAttribute('data-price-txt')} >`;
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', () => handleQuizAddToCart(atcBtn));
    }
  }

  async function handleQuizAddToCart(btn) {
    if (btn.disabled) return;
    const vid = btn.getAttribute('data-vid');
    const qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
    const textEl = document.getElementById('dds-quiz-atc-text');
    const origText = textEl ? textEl.innerText : 'Adaugă în coș >';

    btn.disabled = true;
    if (textEl) textEl.innerText = 'Se adaugă în coș...';

    const formData = new FormData();
    formData.append('id', vid);
    formData.append('quantity', qty);
    formData.append('sections', 'cart-icon-bubble,cart-drawer');
    formData.append('sections_url', window.location.pathname);

    try {
      const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const resp = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      if (!resp.ok) throw new Error('Cart add failed');
      const parsedState = await resp.json();

      if (textEl) textEl.innerText = '✓ Adăugat cu succes!';

      if (parsedState.sections && parsedState.sections['cart-icon-bubble']) {
        const doc = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
        const inner = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
        document.querySelectorAll('[id="cart-icon-bubble"]').forEach(b => {
          b.innerHTML = inner ? inner.innerHTML : parsedState.sections['cart-icon-bubble'];
        });
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && parsedState.sections && parsedState.sections['cart-drawer']) {
        const newDoc = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
        if (cartDrawer.classList.contains('is-empty')) {
          const newDiv = newDoc.getElementById('CartDrawer');
          const oldDiv = document.getElementById('CartDrawer');
          if (newDiv && oldDiv) oldDiv.innerHTML = newDiv.innerHTML;
          cartDrawer.classList.remove('is-empty');
        } else if (cartDrawer.renderContents) {
          const origOpen = cartDrawer.open;
          cartDrawer.open = function () {};
          cartDrawer.renderContents(parsedState);
          setTimeout(() => { cartDrawer.open = origOpen; }, 100);
        }
      }

      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

      setTimeout(() => {
        closeModal();
        btn.disabled = false;
        if (textEl) textEl.innerText = origText;
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon) cartIcon.click();
      }, 350);
    } catch (e) {
      console.error('Quiz ATC error:', e);
      btn.disabled = false;
      if (textEl) textEl.innerText = origText;
      window.location.href = '/cart';
    }
  }
});
